'use strict'
import urls from './Urls'

export const CHILD_API_ENDPOINTS = {
  CONTACT_CARD: 'contactCard',
  SSO_ADMINS: 'ssoAdmins',
  SEARCH: 'orgSearch',
  MEMBER_LIST: 'memberList'
}

// Contact Card
function getContactCardEndPoint () {
  return urls.directoryApiController() + '/' + CHILD_API_ENDPOINTS.CONTACT_CARD
}

// SSO Admins
function getSsoAdminsEndPoint () {
  return urls.directoryApiController() + '/' + CHILD_API_ENDPOINTS.SSO_ADMINS
}

// Organization Search Autocomplete
function getOrgSearchEndPoint () {
  return urls.directoryApiController() + '/' + CHILD_API_ENDPOINTS.SEARCH
}

// Member Listings
function getMemberListApiEndPoint () {
  return urls.directoryApiController() + '/' + CHILD_API_ENDPOINTS.MEMBER_LIST
}

function getOrgDetailEndPoint () {
  return urls.directoryDetailController()
}

function getMemberListEndPoint () {
  return urls.directoryMemberListController()
}

export default {
  getContactCardEndPoint: getContactCardEndPoint,
  getOrgSearchEndPoint: getOrgSearchEndPoint,
  getOrgDetailEndPoint: getOrgDetailEndPoint,
  getMemberListApiEndPoint: getMemberListApiEndPoint,
  getMemberListEndPoint: getMemberListEndPoint,
  getSsoAdminsEndPoint: getSsoAdminsEndPoint
}
